module.exports = __webpack_public_path__ + "static/img/gpt36.3f501eee.png";